import React, { useState } from "react";
import CartModal from "../../Components/CartModal";
import { useCart } from "../../Contexts/CartContext";
import BluelabMultimediapHMeter from "../../Assets/Bluelab Multimedia pH Meter.webp";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS

const Bluelab_Multimedia_pH_Meter = () => {
  const [showModal, setShowModal] = useState(false);
  const { addToCart } = useCart();

  const handleAddToCart = () => {
    const product = {
      id: 35,
      name: "Bluelab Multimedia pH Meter",
      price: 22680,
      image: BluelabMultimediapHMeter,
    };
    addToCart({ ...product, quantity: 1 });
    setShowModal(true);
  };

  return (
    <div className="container mt-3">
      {" "}
      {/* Add margin top to the container */}
      <div className="row">
        <div className="col-md-6">
          <div
            id="productCarousel"
            className="carousel slide"
            data-ride="carousel"
          >
            <div className="carousel-inner">
              <div className="carousel-item active">
                <img
                  src={BluelabMultimediapHMeter}
                  alt="bluelab multimedia pH meter"
                  className="d-block w-100"
                />
              </div>              
            </div>
            <a
              className="carousel-control-prev"
              href="#productCarousel"
              role="button"
              data-slide="prev"
            >
              <span
                className="carousel-control-prev-icon"
                aria-hidden="true"
              ></span>
              <span className="sr-only">Previous</span>
            </a>
            <a
              className="carousel-control-next"
              href="#productCarousel"
              role="button"
              data-slide="next"
            >
              <span
                className="carousel-control-next-icon"
                aria-hidden="true"
              ></span>
              <span className="sr-only">Next</span>
            </a>
          </div>
        </div>

        <div className="col-md-6">
          <div className="product-details">
            <h2 className="product-name">Bluelab Multimedia pH Meter</h2>
            <p className="product-price">₹{22680}</p>
            <button className="btn btn-primary" onClick={handleAddToCart}>
              Add to Cart
            </button>
            <p className="product-description mt-3 text-justify">
              <h5>
                Quick and Precise pH Measurements in the Palm of Your Hand
              </h5>
              Experience fast and accurate pH measurements wherever you are with
              a portable design. This pH meter is ideal for on-the-go readings
              and works across various environments, delivering reliable results
              every time.
              <h5 className="mt-3">Key Features:</h5>
              <ul className="mt-2">
                <li>
                  Fast sensor response ensures quicker, precise pH readings,
                  perfect for busy growers.
                </li>
                <li>
                  Multimedia-friendly design allows for accurate measurements
                  across different environments, including soil, water, and
                  other substrates.
                </li>
                <li>
                  Toughened spear tip for direct root-zone measurement, making
                  it easy to assess pH right at the source.
                </li>
                <li>
                  Simple two-point calibration process maintains long-term
                  accuracy and reliability.
                </li>
                <li>
                  Backlit LCD display makes it easy to capture and read
                  measurements, even in low-light conditions.
                </li>
                <li>
                  Comes with 2 x AAA alkaline batteries included, so you're
                  ready to measure straight out of the box.
                </li>
              </ul>
            </p>
          </div>
        </div>
      </div>
      {/* Conditionally render the CartModal based on showModal */}
      {showModal && <CartModal onClose={() => setShowModal(false)} />}
    </div>
  );
};

export default Bluelab_Multimedia_pH_Meter;
